import api from '../api';
import { store } from '../store/index';


const LOCALSTORAGE_TOKEN_KEY = 'token';

function login(email, password, recaptchaToken, isRetailer) {
    return api.login(email, password, recaptchaToken, isRetailer)
        .then(res => {
            if (res.data.access_token) {
                localStorage.setItem(LOCALSTORAGE_TOKEN_KEY, res.data.access_token);
                store.dispatch('auth/checkRole');
            }
        })
}

function logout() {
    const hasToken = !!getToken();
    if (hasToken) {
        api.logout();
    }
    localStorage.removeItem(LOCALSTORAGE_TOKEN_KEY);
    store.dispatch('resetStore', null, { root: true });
}

function getToken() {
    return localStorage.getItem(LOCALSTORAGE_TOKEN_KEY);
}

function parseToken() {
    try {
        const token = getToken();
        const payload = token.split('.')[1];
        const jwtObj = JSON.parse(atob(payload));
        return jwtObj;
    } catch (e) {
        return false;
    }
}

function isManager() {
    const obj = parseToken();
    return obj && obj.is_manager;
}

function isRetailerGroup() {
    const obj = parseToken();
    return obj && obj.type == 'RETAILER_GROUP';
}


export default {
    login,
    logout,
    getToken,
    isManager,
    isRetailerGroup,
}